
import UIkit from 'uikit'
import Icons from '@/custom/js/uikit-icons.min.js'

UIkit.use(Icons)

export default {
  name: 'App'
}
